import { useRef, useMemo, useEffect } from "react";
import { P as POINTER_DRAG_THRESHOLD } from "./graph-W6vrFcBu.js";
function usePointerDragState() {
  const pointerAtDown = useRef(null);
  const pointerIsDown = useRef(false);
  const pointerMovedSinceDown = useRef(false);
  const dragged = useRef(false);
  return useMemo(
    () => ({
      pointerAtDown,
      pointerIsDown,
      pointerMovedSinceDown,
      dragged
    }),
    []
  );
}
function useBoardPointerTracking(board, dragState, threshold = POINTER_DRAG_THRESHOLD) {
  useEffect(() => {
    if (!board) {
      return;
    }
    function handler(e) {
      const pointerAtDown = dragState.pointerAtDown.current;
      if (!dragState.pointerIsDown.current || !pointerAtDown) {
        return;
      }
      if (Math.abs(e.x - pointerAtDown[0]) > threshold || Math.abs(e.y - pointerAtDown[1]) > threshold) {
        dragState.pointerMovedSinceDown.current = true;
      }
    }
    board.on("move", handler);
    return () => {
      board.off("move", handler);
    };
  }, [board, dragState, threshold]);
}
export {
  useBoardPointerTracking as a,
  usePointerDragState as u
};
